import {
  DateFormat,
  EmptySectionCard,
  TagProps,
  TreatmentEpisodeCard,
} from '@equip.health/ui';

import { AdminEpisode } from '~/lib/constants/patients.constants';
import {
  episodeStatusMapper,
  getDiffInWeeks,
  levelTagColorMapper,
} from '~/lib/util/patient.util';
import { toLocalMidnight } from '~/lib/util/date.util';

interface PatientAdminEpisodeListProps {
  episodes: AdminEpisode[];
  id: string;
}

const PatientAdminEpisodeList: React.FC<PatientAdminEpisodeListProps> = ({
  episodes,
  id,
}) => {
  if (!episodes?.length) {
    return (
      <EmptySectionCard
        caption="There are no admin episodes associated with this patient"
        id={id}
      />
    );
  }

  return (
    <>
      {episodes.map((episode) => {
        const numWeeks =
          episode.episodeStartDate && episode.episodeClosedDate
            ? getDiffInWeeks(
                episode.episodeStartDate,
                episode.episodeClosedDate,
                DateFormat.shortYearMonthDay,
              )
            : getDiffInWeeks(
                episode.episodeStartDate,
                new Date().toISOString().slice(0, 10),
                DateFormat.shortYearMonthDay,
              );

        return (
          <TreatmentEpisodeCard
            admitDate={toLocalMidnight(new Date(episode.episodeStartDate))}
            closedDate={
              episode.episodeClosedDate
                ? toLocalMidnight(new Date(episode.episodeClosedDate))
                : null
            }
            id={id}
            key={episode.episodeExternalId}
            level={
              episode.level && {
                color: levelTagColorMapper[episode.level.toLowerCase()],
                id: episode.level,
                value: episode.level,
              }
            }
            numWeeks={numWeeks}
            onClick={null}
            status={{
              color: episodeStatusMapper[episode.episodeStatus]
                .tagColor as TagProps['color'],
              id: episode.episodeStatus,
              value: episode.episodeStatus,
            }}
            treatmentProgram={episode.treatmentProgramName}
          />
        );
      })}
    </>
  );
};

export default PatientAdminEpisodeList;
